import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["container"]

  initialize() {
    this.sortableMap = new Map()
  }

  disconnect() {
    this.sortableMap.forEach(sortable => sortable.destroy())
    this.sortableMap.clear()
  }

  containerTargetConnected(element) {
    const sortable = Sortable.create(element, {
      group: "canvas-cards",
      animation: 150,
      ghostClass: "opacity-50",
      chosenClass: "shadow-lg",
      dragClass: "cursor-grabbing",
      handle: ".drag-handle",
      draggable: ".canvas-card",
      onEnd: this.handleSortEnd.bind(this)
    })
    this.sortableMap.set(element, sortable)
  }

  containerTargetDisconnected(element) {
    const sortable = this.sortableMap.get(element)
    if (sortable) {
      sortable.destroy()
      this.sortableMap.delete(element)
    }
  }

  async handleSortEnd(event) {
    const cardElement = event.item
    const cardId = cardElement.dataset.cardId
    const newBlockId = event.to.dataset.blockId
    const newPosition = event.newIndex

    // Skip if nothing changed
    if (event.from === event.to && event.oldIndex === event.newIndex) {
      return
    }

    try {
      const response = await patch(`/workspace/canvas_cards/${cardId}/reorder`, {
        body: JSON.stringify({
          canvas_card: {
            canvas_block_id: newBlockId,
            position: newPosition
          }
        }),
        contentType: "application/json",
        responseKind: "json"
      })

      if (!response.ok) {
        const data = await response.json
        console.error("Failed to reorder card:", data.error)
      }
    } catch (error) {
      console.error("Error reordering card:", error)
    }
  }
}
